import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { ProductStandardListsState } from "../../models/mp-admin/product-standard-lists-state";

const initialState: ProductStandardListsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(AdminProductsActions.productStandardLists.getApi, (state) => ({
		...state,
		loading: true
	})),
	on(AdminProductsActions.productStandardLists.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		...action.state,
		loading: false
	})),
	on(AdminProductsActions.productStandardLists.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(AdminProductsActions.productStandardLists.invalidate, () => initialState)
);

export function productStandardListsReducer(
	state: ProductStandardListsState | undefined,
	action: Action
): ProductStandardListsState {
	return reducer(state, action);
}
